import http from '../../../../api/http';

const BASE_URL = '/mypage/corporationInfo';
const API_URL = `${BASE_URL}`;

// 기업정보 조회
function retrieveAllCorpoInfoPaging(params) {
    return http.post(`${API_URL}/retrieveAllCorpoInfoPaging`, params)
}

// 기업홍보관 기업정보 등록 유무
function retrieveCorpInfoPrivacyAgreeYnByCorpId(corpId) {
    return http.get(`${API_URL}/retrieveCorpInfoPrivacyAgreeYnByCorpId?corpId=${corpId}`)
}

// 기업정보 상세
function retrieveCorporation(corpId) {
    return http.get(`${API_URL}/retrieveCorporation?corpId=${corpId}`)
}

// 입사지원 유무
function retrieveApplicantByUserId(params) {
    return http.post(`${API_URL}/applicant/retrieveApplicantByUserId`, params)
}

// 입사지원
function createApplicant(params) {
    return http.post(`${API_URL}/applicant/createApplicant`, params)
}

// 입사지원 이력서 리스트
function retrieveResumeListPagingByUserId(params) {
    return http.post(`${API_URL}/resume/retrieveResumeListPagingByUserId`, params)
}

// 강의 신청 이력서 상세
function retrieveUserLectureRecord(userId, lectId, regDt) {
    return http.get(`${API_URL}/resume/retrieveUserLectureRecord?userId=${userId}&lectId=${lectId}&regDt=${regDt}`)
}

// 기업정보 등록
function createCorpInfo(params) {
    return http.post(`${API_URL}/createCorpInfo`, params)
}

// 기업정보 수정
function updateCorpInfo(params) {
    return http.post(`${API_URL}/updateCorpInfo`, params)
}

// 입사지원 현황 리스트 (기업/재직자)
function retrieveApplicantListPagingByCorpId(params) {
    return http.post(`${API_URL}/applicant/retrieveApplicantListPagingByCorpId`, params)
}

// 이력서 다운로드 (엑셀)
function retrieveApplicantListExcelByCorpId(params) {
    return http.post(`${API_URL}/applicant/retrieveApplicantListExcelByCorpId`, params, {
        responseType: 'blob',
    })
}

// 입사지원 이력서 상세
function retrieveApplicantResume(resumeId, hidden) {
    return http.get(`${API_URL}/resume/retrieveApplicantResume?resumeId=${resumeId}&hidden=${hidden}`)
}

// 입사지원 상태변경
function updateApplyStateGb(params) {
    return http.post(`${API_URL}/applicant/updateApplyStateGb`, params)
}

// 입사지원 현황 리스트 (학생/취업준비생)
function retrieveApplicantListPagingByUserId(params) {
    return http.post(`${API_URL}/applicant/retrieveApplicantListPagingByUserId`, params)
}

export default {
    retrieveAllCorpoInfoPaging,
    retrieveCorpInfoPrivacyAgreeYnByCorpId,
    retrieveCorporation,
    retrieveApplicantByUserId,
    createApplicant,
    retrieveResumeListPagingByUserId,
    retrieveUserLectureRecord,
    createCorpInfo,
    updateCorpInfo,
    retrieveApplicantListPagingByCorpId,
    retrieveApplicantListExcelByCorpId,
    retrieveApplicantResume,
    updateApplyStateGb,
    retrieveApplicantListPagingByUserId,
};
